import { useEffect, useState } from "react"
import { usePageContext } from "vike-react/usePageContext"
import { useCategories } from "./useCatalogData"
import { stripLang } from "../utils/contentRoutes"
import { pathBetween, trailOf } from "../utils/categories"

// The last category path browsed in this tab: a product opened from it is
// shown under that path, not under its first category.
const LAST_TRAIL = "aldoo-category-trail"

/** The category path of the page, as the visitor followed it (/category/<a>/<b>), or null. */
export function useCategoryTrail() {
  const pageContext = usePageContext()
  const { list } = useCategories()
  const segments = stripLang(pageContext.urlPathname || "/").split("/").filter(Boolean)
  if (segments[0] !== "category") return null
  return trailOf(segments.slice(1), list)
}

/** Remember the path of the category page being read, for the products opened from it. */
export function useRememberTrail(trail) {
  const key = trail?.map((cat) => cat.categoryId).join("/") || ""
  useEffect(() => {
    if (!key) return
    try {
      sessionStorage.setItem(LAST_TRAIL, key)
    } catch {}
  }, [key])
}

/**
 * The path to show a product under: the one the visitor came down, when the
 * product is in that category or under it — ending at the product's own
 * category — else null (its first category's path is shown).
 */
export function useBrowsedPath(productCategories) {
  const { list } = useCategories()
  const [path, setPath] = useState(null)
  const categoriesKey = (productCategories || []).join(",")
  useEffect(() => {
    let slugs = ""
    try {
      slugs = sessionStorage.getItem(LAST_TRAIL) || ""
    } catch {}
    const trail = trailOf(slugs.split("/").filter(Boolean), list)
    if (!trail) return setPath(null)
    const leaf = trail[trail.length - 1].categoryId
    for (const categoryId of productCategories || []) {
      const below = pathBetween(leaf, categoryId, list)
      if (below) return setPath([...trail, ...below.slice(1)])
    }
    setPath(null)
  }, [categoriesKey, list])
  return path
}
